<template>
    <f7-page>
    </f7-page>
</template>
<script>
    export default {
        mounted() {
            console.log('123');

        }
    }
</script>